import { render, staticRenderFns } from "./ProductVariation.vue?vue&type=template&id=6df87262&"
import script from "./ProductVariation.vue?vue&type=script&lang=js&"
export * from "./ProductVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df87262')) {
      api.createRecord('6df87262', component.options)
    } else {
      api.reload('6df87262', component.options)
    }
    module.hot.accept("./ProductVariation.vue?vue&type=template&id=6df87262&", function () {
      api.rerender('6df87262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductVariation.vue"
export default component.exports